import './index.css';
import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Close } from "../../icons/svg/menu_ic/close_match.svg"
import MTagsApp from './TagsApp';
import useOutside from '../../customHooks/useOutside';
import { useDispatch } from 'react-redux';
import { getTagsList } from './actions/getTagsList';

const DDSelectTags = ({path, active, setActive, updateTagList, tagsInList, removeTagFromTagList, taskId, modalShow}) => {
    const dispatch = useDispatch();
    const [wordsCounter, setWordsCounter] = useState();
    const [matchRegExp, setMatchRegExp] = useState('');
    const [isActiveCounter, setIsActiveCounter] = useState(false);
    const maxLenghtOfTitle = 60;
    const [windowScreen, setWindowScreen] = useState(window.screen.width);
    const [widthInputTag, setWidthInputTag] = useState('80%');
    const refInputTag = useRef();
    const onCloseRef = useOutside(() => setActive(false))
    function checkLenghtOfWords(value) {
        if (value.length === 35) {
            return setWordsCounter(value.length) & setIsActiveCounter(true);
        } else if ((value.length >= 35) & (value.length <= maxLenghtOfTitle)) {
            return setWordsCounter(value.length);
        } else if (value.length < 35) {
            return setIsActiveCounter(false);
        }
    }

    useEffect(() => {
        if (active) {
            dispatch(getTagsList())
        }
        // eslint-disable-next-line
    }, [active])

    useEffect(() => {
        const handleUpdateScreenWidth = () => {
          setWindowScreen(window.screen.width)
        }
    
        window.addEventListener('resize', handleUpdateScreenWidth);
    
        return () => {
          window.removeEventListener('resize', handleUpdateScreenWidth);
        };
      }, [windowScreen])
    

    useEffect(() => {
        if (!active) {
            setMatchRegExp('')
        }
    }, [setMatchRegExp, active])
    
    function resizeTagInput(e) {
        if (e.target.scrollWidth < 230) {
            return
        } else if (e.target.value === '') {
            setWidthInputTag('200px');
        } else {
            setWidthInputTag(e.target.scrollWidth + 'px');
        }    
    }
    function stopEnter(e) {
        if (e.code === 'Enter') {
            e.stopPropagation()
            e.preventDefault()
        }
    }

    const closeFinder = () => {
        setMatchRegExp('')
        setWidthInputTag('200px')
        setWordsCounter(0)
        setIsActiveCounter(false)
    }

    useEffect(() => {
        if (active && windowScreen > 576) {
            refInputTag.current.focus()
        }
        
    }, [refInputTag, active, windowScreen])

    return(
        <div ref={onCloseRef} className={active ? 'menu active' : 'menu'} >
            <div className={path === 'addTask' ? 'tags__container' : 'tags__container__edit-task'} 
                onClick={e => e.stopPropagation()}>
                <form onKeyDown={(e) => stopEnter(e)}>
                    <div className='tags__get-tag-container'>
                        <div className='tags_get-tag__input'>
                            <input type="text"
                                ref={refInputTag} 
                                maxLength='60'
                                placeholder="Введите название метки" 
                                className='tags__get-tag ym-disable-keys'
                                value={matchRegExp} 
                                style={{width: widthInputTag}}
                                onInput={(e) => setMatchRegExp(e.target.value) & resizeTagInput(e)} 
                                onChange={(e) => checkLenghtOfWords(e.target.value)}/>
                            <div style={matchRegExp ? {display: 'block'} : {display: 'none'}}>
                                <Close style={{marginLeft: '20px', cursor: 'pointer'}} 
                                    onClick={() => closeFinder()}/>
                            </div>
                        </div>
                        <p className={isActiveCounter ? 'ddselect-alert alertCounterLengthOfTitle ' : 'hide'}>
                            Лимит {wordsCounter}/60 
                        </p>
                    </div>
                </form>
                <div className="tags__line"></div>
                <div className='tags__data-container'>
                    <MTagsApp matchRegExp={matchRegExp}
                        modalShow={modalShow}
                        taskId={taskId}
                        tagsInList={tagsInList}
                        removeTagFromTagList={removeTagFromTagList}
                        updateTagList={updateTagList}
                        />
                </div>
            </div>
        </div>
    )
}

export default DDSelectTags;